<template>
    <div class="user-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('releaseFlow.step')}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-autocomplete
                                    v-model="form.relationships['departments'].data"
                                    :items="departments"
                                    v-bind:label="$t('releaseFlow.department')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    return-object
                            ></v-autocomplete>
                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                            <v-btn color="primary" @click="deleteAction(form.id)">
                                {{$t('message.delete')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {

            this.$store.dispatch('departments/loadAll').then(() => {
                const widgets = this.$store.getters['departments/all'];
                widgets.forEach((item) => {
                    this.departments.push(item);
                });
            });

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('releaseSteps/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['releaseSteps/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('departments/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['departments/related']({parent});
                        this.form.relationships['departments'].data = [];
                        this.form.relationships['departments'].data = related;
                    });
                });
            } else {

            }



        },
        methods: {

            deleteAction: function() {
                this.$store.dispatch('releaseSteps/delete', {id: this.id}).then(() => {
                    this.$router.go(-1);
                });
            },

            saveAction: function () {
                if (this.$route.params.id != null) {
                    //this.form.id = this.$route.params.id;
                    var widget = this.$store.getters['releaseSteps/byId']({id: this.form.id});
                    widget = this.form;
                    //console.log(this.form);

                    console.log(widget);

                    delete widget.relationships['departments'].data.relationships;
                    delete widget.relationships['departments'].data.attributes;
                    delete widget.relationships['departments'].data.links;

                    console.log(widget);

                    this.$store.dispatch('releaseSteps/update', widget).then(() => {
                        this.$router.go(-1);
                    });
                } else {
                    var widget = this.form;

                    delete widget.relationships['departments'].data.relationships;
                    delete widget.relationships['departments'].data.attributes;
                    delete widget.relationships['departments'].data.links;

                    if(widget.relationships['departments'].data.type == undefined)
                        delete widget.relationships['departments'];

                    widget.attributes.release_flow_id = this.$route.params.flowid;

                    this.$store.dispatch('releaseSteps/create', widget).then(() => {
                        this.$router.go(-1);
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "releaseSteps/isLoading",
                error: "releaseSteps/isError",
            }),
        },
        data: () => ({

            form: {
                attributes: {
                    title: '',
                },
                relationships: {
                    'departments': {data: []},
                },
            },

            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            departments: [],
        })
    }
</script>
